<template>
    <div class="SummaryPoints">
        <div class="schemeCard p-3">
            <div class="d-flex justify-content-between" style="align-items: center">
                <h6 class="mb-1">Summary</h6>
            </div>

            <div class="row">
                <div class="col-12 p-2 eligible-section text-center">
                    <h3 v-if="schemeDetail.isHerirachyScheme">
                        {{schemeEnrollmentObj.eligiblePoint+schemeEnrollmentObj.myTeamEligiblePoint-schemeEnrollmentObj.earnPoint-schemeEnrollmentObj.myTeamEarnPoint}}</h3>
                    <h3 v-else>
                        {{schemeEnrollmentObj.eligiblePoint-schemeEnrollmentObj.earnPoint}}</h3>
                    <p>Eligible</p>
                </div>
                <div class="w-100">
                    <ul class="row" style="list-style: none">
                        <li class="col-10 text-left">
                            <p class="mb-0 bankLabel">Description</p>
                        </li>
                        <li class="col-2 text-right">
                            <p class="mb-0 bankLabel mr-3">Amount</p>
                        </li>
                    </ul>
                    <ul class="scheme-total col-12 " style="list-style: none">
                        <li>
                            <div class="row">
                                <div class="col-10 text-left"><span>Total Earned</span></div>
                                <div class="col-2 text-right pr-2">
                                    <span style="width: 20%;" class="mr-2">+</span>
                                    <span v-if="schemeDetail.isHerirachyScheme">{{schemeEnrollmentObj.myTeamEarnPoint+schemeEnrollmentObj.earnPoint}} </span>
                                    <span v-else>{{schemeEnrollmentObj.earnPoint}} </span>
                                </div>
                            </div>
                        </li>
                        <li class="mb-2" v-if="!schemeDetail.isSpecialScheme">
                            <div @click="openAdjustmentHistory" class="row">
                                <div class="col-10 text-left">
                                    <strong style="color: #0f5992;cursor: pointer">Adjustment</strong>
                                </div>
                                <div class="col-2 text-right pr-2">
                                    <span style="width: 20%;" class="mr-2">+</span>
                                    <span>{{schemeEnrollmentObj.adjustment}}</span>
                                </div>
                            </div>
                        </li>
                        <li class="mb-2">
                            <div @click="openReturnOrderHistory" class="row">
                                <div class="col-10 text-left">
                                    <strong style="color: #0f5992;cursor: pointer">Return Order Points</strong>
                                </div>
                                <div class="col-2 text-right">
                                    <span style="width: 20%;" class="mr-2">-</span>
                                    <span class="mr-2" style="width: auto">{{schemeEnrollmentObj.returnOrderPoint}}</span>
                                </div>
                            </div>
                        </li>
                        <li class="mb-2">
                            <div class="row">
                                <div class="col-10 text-left">
                                    <span>Redeemed</span>
                                </div>
                                <div class="col-2 text-right">
                                    <span style="width: 20%;" class="mr-2">-</span>
                                    <span class="mr-2" style="width: auto">{{schemeEnrollmentObj.redemPoint}}</span>
                                </div>
                            </div>
                        </li>
                        <li class="mb-2">
                            <div class="row">
                                <div class="col-10 text-left">
                                    <span>Redeem In Progress</span>
                                </div>
                                <div class="col-2 text-right">
                                    <span style="width: 20%;" class="mr-2">-</span>
                                    <span class="mr-2"
                                          style="width: auto">{{schemeEnrollmentObj.redemptioInProgress}}</span>
                                </div>
                            </div>
                        </li>
                        <li class="mb-2" v-if="schemeEnrollmentObj.transferPoints">
                            <div @click="openTransferHistory" class="row">
                                <div class="col-10 text-left">
                                    <strong style="color: #0f5992;cursor: pointer">Transfer Points</strong>
                                </div>
                                <div class="col-2 text-right">
                                    <span style="width: 20%;" class="mr-2">-</span>
                                    <span class="mr-2" style="width: auto">{{schemeEnrollmentObj.transferPoints}}</span>
                                </div>
                            </div>
                        </li>
                        <hr style="border: 0.5px dashed grey">
                        <li>
                            <div class="row mt-2 pr-2">
                                <div class="col-10 text-left">
                                    <span>Redeemable Points</span>
                                </div>
                                <div class="col-2 text-right">
<!--                                    <span style="width: 20%;" class="mr-2">=</span>-->
                                    <strong>{{calculateClosingPoints(schemeEnrollmentObj, schemeDetail)}}</strong>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
  export default {
    name: 'SummaryPoints',
    props: ['schemeEnrollmentObj', 'schemeDetail'],
    methods: {
      openAdjustmentHistory () {
        this.$emit('showAdjustmentHistory')
      }, openReturnOrderHistory () {
        this.$emit('showReturnOrderHistory')
      },openTransferHistory () {
            this.$emit('showTransferHistory')
      },
    },
  }
</script>

<style scoped>

</style>
